export default __webpack_public_path__ + "static/media/school-supplies.996630ed.png";